// Components
import SantaAfterXmas from './components/Santa/SantaAfterXmas';
import SantaComingSoon from './components/Santa/SantaComingSoon';
import SantaErrorPage from './components/Santa/SantaError';

// CSS
import './App.css';

function App() {
  if (process.env.REACT_APP_SANTA_MODE?.trim().toUpperCase() === 'AFTER_XMAS') {
    return <SantaAfterXmas />;
  }

  if (process.env.REACT_APP_SANTA_MODE?.trim().toUpperCase() === 'COMING_SOON') {
    return <SantaComingSoon />;
  }

  if (process.env.REACT_APP_SANTA_MODE?.trim().toUpperCase() === 'ERROR') {
    return <SantaErrorPage />;
  }
}

export default App;
